import { render, staticRenderFns } from "./MiniviewCard.vue?vue&type=template&id=637cea6d"
import script from "./MiniviewCard.vue?vue&type=script&lang=js"
export * from "./MiniviewCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports